// ----------------------------------------------------------------------

export function localStorageAvailable() {
    try {
        const key = "__some_random_key_you_are_not_going_to_use__"
        window.localStorage.setItem(key, key)
        window.localStorage.removeItem(key)
        return true
    } catch (error) {
        return false
    }
}

export function localStorageGetItem(key: string, defaultValue = "") {
    const storageAvailable = localStorageAvailable()

    let value

    if (storageAvailable) {
        value = localStorage.getItem(key) || defaultValue
    }

    return value
}

export const getItemFromLocalStorage = (key: string) => {
    try {
        return key ? localStorage.getItem(key) : null
    } catch (error) {
        return null
    }
}

export const isJobDetails = () => {
    const pathname = window.location.pathname
    const url = window.location.href
    // Check pathname first (more reliable for routing)
    const pathnameMatch =
        pathname?.includes("/jobDetails/") ||
        pathname?.includes("/jobDetailsV2/") ||
        pathname?.includes("/reschedule/") ||
        pathname?.includes("/interview/") ||
        pathname?.includes("/jobOverview/")
    // Also check full URL as fallback (handles cases where params might be in pathname)
    const urlMatch =
        !!url?.match(/interview\/.+/i) ||
        !!url?.match(/jobDetails\/([a-f0-9-]+)/i)?.[1] ||
        !!url?.match(/jobDetailsV2\/([a-f0-9-]+)/i)?.[1] ||
        !!url?.match(/reschedule\/.+/i) ||
        !!url?.match(/jobOverview\/.+/i)
    return pathnameMatch || urlMatch
}
